<template>
	<div class="account-saldo-page">

		<!-- SPINNER -->
		<div class="text-center p-4" v-if="isLoading">
			<i class="fa fa-spin fa-cog" style="font-size: 3em;"></i>
		</div>

		<template v-else-if="isValid">

			<!-- MSISDN NUMBER INFO -->
			<div class="box-account-info" v-if="!hideNumberSpinner">
				<table>
					<tr>
						<th>Número:</th>
						<td>
							{{ msisdn | msisdnToPhone }}
							<span v-if="isLoading" key="isLoading">
								<i class="fa fa-spin fa-cog"></i>
							</span>
						</td>
					</tr>
					<tr v-if="!!fetchedData">
						<th>IMEI:</th>
						<td>{{ fetchedData.responseSubscriber.information.IMEI }}</td>
					</tr>
				</table>
			</div>

			<!-- HR -->
			<template v-if="!isLoading">

				<table v-if="hasSuscription">
					<tr v-if="'primaryOffering' in fetchedData">
						<th>Plan contratado:</th>
						<td>{{ fetchedData.primaryOffering.planName || 'S/I' }}</td>
					</tr>
					<tr v-if="corteMensual">
						<th>Fecha de corte mensual:</th>
						<td>
							{{ corteMensual | humanizar_fecha }}
						</td>
					</tr>
					<tr v-if="pricingAndBilling">
						<th>Siguiente cobro:</th>
						<td>
							{{ pricingAndBilling.suscriptionCost | currency }}
							el
							{{ pricingAndBilling.nextBillingDate | humanizar_fecha }}
							<i class="fa fa-info-circle" v-b-tooltip.hover
								title="Éste costo puede incluir varias lineas en una misma suscripción."></i>
						</td>
					</tr>
				</table>

				<hr>

				<!-- CONTENT TAB -->
				<div v-if="!!fetchedData" class="box-tab-1 animate__animated animate__animatedFadeInUp">

					<dn-progress-bar label="SMS" v-if="!!fetchedData.personalized.sms && showSMS"
						:total="fetchedData.personalized.sms.total" :used="fetchedData.personalized.sms.used">
						<div slot="reference">
							{{ fetchedData.personalized.sms.used }} de {{ fetchedData.personalized.sms.total }} SMS
						</div>
					</dn-progress-bar>

					<dn-progress-bar label="Datos" v-if="parseInt(fetchedData.personalized.data.total)" :total="fetchedData.personalized.data.total" :used="fetchedData.personalized.data.used">
						<div slot="reference">
							{{ fetchedData.personalized.data.used + fetchedData.personalized.reduced.total | mb2gb }} /
							{{ fetchedData.personalized.data.total + fetchedData.personalized.reduced.total | mb2gb }}
						</div>
						<div slot="overlabel">
							<span class="imoon-meter"></span> {{ speedConnection }}
						</div>
					</dn-progress-bar>
					
					<b-jumbotron class="text-center" v-else>
						<template #header>
							No tienes datos disponibles.
						</template>
					</b-jumbotron>

					<dn-progress-bar v-if="showMins" label="Minutos" :total="fetchedData.personalized.minutes.total"
						:used="0" unit="Minutos" unlimited>
						<div slot="reference">
							∞ ILIMITADOS
						</div>
					</dn-progress-bar>

					<dn-progress-bar v-if="showSocials" label="Redes sociales"
						:total="fetchedData.personalized.data.total" :used="0" unlimited>
						<div slot="reference">
							∞ ILIMITADAS
						</div>
					</dn-progress-bar>

					<hr>

					<dn-progress-bar label="Velocidad reducida"
						v-if="!!fetchedData.personalized.reduced && showReducedData"
						:total="fetchedData.personalized.reduced.total" :used="fetchedData.personalized.reduced.used">
						<div slot="reference">
							{{ fetchedData.personalized.reduced.used | mb2gb }} / {{
								fetchedData.personalized.reduced.total
								|
								mb2gb }}
						</div>
					</dn-progress-bar>

					<msisdn-recharge-history class="mt-2" :charge-history="chargeHistory" :calls-history="callsHistory"
						:msisdn="msisdn" :hide-historial-button="hideHistorialButton" hideMSISDN />

				</div>

				<div class="beneficios">
					<h6 class="mt-2">
						BENEFICIOS ILIMITADOS:
					</h6>
					<div class="beneficios-holder mb-4">
						<span>Redes sociales ilimitadas</span>
						<span>Radio PRIP® ilimitado</span>
						<span>Llamadas y mensajes ilimitados</span>
					</div>
					<h6 class="mt-2">
						OTROS BENEFICIOS:
					</h6>
					<div class="beneficios-holder mb-4">
						<span>Datos USA y Canada incluidos</span>
					</div>
				</div>

				<template v-if="esimConfig && esimConfig.lpa_string && esimQRMode === 'inline'">
					<b-tabs class="mt-3" card>
						<b-tab title="Código de Android">
							<div class="qr-code-container">
								<canvas id="canvas-android"></canvas>
							</div>
						</b-tab>
						<b-tab title="Código de iOS">
							<div class="qr-code-container">
								<canvas id="canvas-ios"></canvas>
							</div>
						</b-tab>
					</b-tabs>
				</template>

			</template>

			<b-card class="tool-bar text-right mt-4"
				v-if="esimConfig && esimQRMode === 'modal'">
				<b-button-group size="sm">
					<b-button variant="info" @click="$refs.detailsSIMModal.show">
						Detalles de SIM
						<!-- <span class="imoon-qr_code_2"></span> -->
					</b-button>
				</b-button-group>
				<b-button-group size="sm" v-if="esimConfig.lpa_string">
					<b-button variant="primary" @click="triggerOpenESIMModal">
						Ver eSIM
						<span class="imoon-qr_code_2"></span>
					</b-button>
				</b-button-group>
			</b-card>

		</template>

		<!-- MSG -->
		<div v-if="!!msg" class="text-center animate__animated animate__animatedFadeInUp warning-msg">
			{{ msg | altanFixLabel }}
		</div>

		<b-modal id="detallesSIM" title="Detalles SIM" ref="detailsSIMModal" v-if="fetchedData" hide-footer>
			<template #modal-header-close>
				<b-button variant="link" class="close" @click="$refs.detailsSIMModal.hide()" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</b-button>
			</template>
			<table class="table table-striped">
				<tr>
					<th>IMEI:</th>
					<td>{{ fetchedData.responseSubscriber.information.IMEI || 'S/I' }}</td>
				</tr>
				<tr>
					<th>ICCID:</th>
					<td>{{ fetchedData.responseSubscriber.information.ICCID || 'S/I' }}</td>
				</tr>
				<tr>
					<th>IMSI:</th>
					<td>{{ fetchedData.responseSubscriber.information.IMSI || 'S/I' }}</td>
				</tr>
				<tr v-if="lineStatus">
					<th>Estatos de Línea:</th>
					<td>{{ lineStatus || 'S/I' }}</td>
				</tr>
			</table>
		</b-modal>

		<esim-qrcode-modal ref="esimQrcodeModal" :qr-code-options="QRCodeOptions" />

	</div>
</template>

<script>
import DnProgressBar from '../daniel/dn-progress-bar.vue'
import MsisdnRechargeHistory from '../daniel/msisdnRechargeHistory.vue'
import QRCode from 'qrcode'
import esimQrcodeModal from './esim-qrcode-modal.vue'


export default {
	name: 'accountSaldoPage',
	components: {
		DnProgressBar,
		MsisdnRechargeHistory,
		esimQrcodeModal
	},
	props: {
		esimQRMode: {
			type: String,
			default: 'modal' //[modal|inline]
		},
		showSMS: {
			type: Boolean,
			default: false
		},
		showMins: {
			type: Boolean,
			default: false
		},
		showSocials: {
			type: Boolean,
			default: false
		},
		showReducedData: {
			type: Boolean,
			default: false
		},
		hideNumberSpinner: {
			type: Boolean,
			default: false
		},
		QRCodeOptions: {
			type: Object,
			default: () => {
				return { width: 300 }
			}
		},
		hideHistorialButton: {
			type: Boolean,
			default: false
		},
		msisdn: {
			type: [String, Number],
			required: true
		}
	},
	data: () => {
		return {
			isLoading: false,
			isValid: null,
			msg: null,
			fetchedData: null,
			esimConfig: null,
			chargeHistory: [],
			uf: null,
			callsHistory: []
		}
	},
	computed: {
		hasSuscription() {
			return ('suscription' in this.fetchedData && this.fetchedData.suscription !== null)
		},
		lineStatus() {
			try {
				return this.fetchedData.responseSubscriber.status.subStatus;
			} catch (e) {
				console.log(e)
				return false;
			}
		},
		corteMensual() {
			try {
				return this.fetchedData.personalized.data.expireDate.date;
			} catch (e) {
				console.log(e)
				return false;
			}
		},
		pricingAndBilling() {
			try {
				return {
					precio: this.fetchedData.primaryOffering.precio,
					suscriptionCost: (this.fetchedData.suscription.plan.leftToBill / 100),
					suscriptionTotalAmount: (this.fetchedData.suscription.plan.totalAmount / 100),
					nextBillingDate: this.fetchedData.suscription.plan.nextBillingDate
				}
			} catch (e) {
				console.log(e)
				return false
			}
		},
		isLoaded() {
			return this.isValid !== null
		},
		speedConnection() {
			if (!this.isLoaded)
				return 'Speed unknown';
			else if (this.uf === null)
				return 'No speed information';
			else if ('throttling' in this.uf)
				return this.uf.throttling.diagnose;
			else
				return this.uf + ' Kbps';
		},
	},
	methods: {
		triggerOpenESIMModal() {
			if ('esimQrcodeModal' in this.$refs)
				this.$refs.esimQrcodeModal.show(this.esimConfig.lpa_string)
			else
				console.error('esimQrcodeModal not found')
		},
		async loadUp() {
			try {
				let response = await axios.get('skyaccount/msisdncheckadvance/' + this.msisdn)

				if (!_.isObjectLike(response))
					throw 'Error en la respuesta el servidor';

				if (!response.status)
					throw response.msg;

				this.msg = response.msg
				this.isValid = (!!response.status)


				if (this.isValid) {
					this.fetchedData = response.data
					this.fetchedData.primaryOffering = ('primaryOffering' in response) ? response.primaryOffering : null;
					this.fetchedData.suscription = ('suscription' in response) ? response.suscription : null;
					this.uf = response.uf;
				} else {
					this.uf = null
				}

				this.chargeHistory = response.historial || [];
				this.callsHistory = response.historial_llamadas || [];
				this.esimConfig = response.esimConfig || null;

				setTimeout(() => {
					QRCode.toCanvas(document.getElementById('canvas-android'), response.esimConfig.lpa_string, this.QRCodeOptions, (error) => {
						if (error) console.error(error)
						console.log('success!');
					})
					QRCode.toCanvas(document.getElementById('canvas-ios'), "https://esimsetup.apple.com/esim_qrcode_provisioning?carddata=" + response.esimConfig.lpa_string, this.QRCodeOptions, (error) => {
						if (error) console.error(error)
						console.log('success!');
					})
				}, 200)

				this.$emit('success', response)

				return true;
			} catch (e) {
				// notify(e)
				this.isValid = false
				this.msg = e
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				this.$emit('fail', e)
				console.error(e)
			}
		}
	},
	async mounted() {
		this.isLoading = true
		await this.loadUp()
		this.isLoading = false
	}
}
</script>

<style lang="scss">
@import '@/sass/utils/_variables.scss';
$size: 15em;

.account-saldo-page {

	.tool-bar {
		background-color: $primary-dark;
	}

	.warning-msg {
		color: $danger;
		font-size: 1.2em;
		margin-top: 2em;
		text-transform: uppercase;
		margin: 2em 0;
	}


	hr {
		border-top: 1px solid hsla(24, 91%, 53%, 0.37);
	}


	table {
		th {
			min-width: 13em;
			text-align: right;
			padding-right: 1.7em;
		}

		td {
			color: $accent;
		}
	}


	.nav-tabs .nav-link.active,
	.nav-tabs .nav-item.show .nav-link {
		color: $black;
		background-color: $accent;
		border-color: $accent $accent #111;
	}



	.qr-code-container {
		text-align: center;

		canvas {
			padding: 1em;
			width: $size !important;
			height: $size !important;
		}
	}

	&+.account-saldo-page {
		margin-top: 3em;
	}

	// .box-tab-1 {
	.box-bar {
		.col-title {
			text-align: left;
			margin-left: 12.5em;
		}
	}

	@media screen and (max-width: 768px) {
		table {
			// background-color: purple;
			width: 100%;

			tr {
				display: flex;
				flex-flow: column;

				&,
				td,
				th {
					text-align: left;
				}

				td {
					padding-left: 1em;
				}
			}
		}

		.box-bar {
			// background-color: red;
			flex-flow: column;

			.progress-label {
				// background-color: blue;
				text-align: left;
				flex: 1 0 auto;
				line-height: inherit !important;
			}

			.progress-holder {
				padding-left: 2em;
			}
		}
	}

	// }

	.beneficios {
		h6 {
			color: white !important;
		}

		&-holder {
			margin-top: 1em;
			display: flex;
			flex-flow: wrap;
			gap: 0.5em;

			span {
				background-color: $primary-dark;
				padding: 0.25em 0.9em;
				border-radius: 1em;
				color: $accent;
				border: 1px solid $accent;
			}
		}
	}
}

#detallesSIM {
	.table {
		/* color: #212529; */
		color: #a2a2a2;

		tr:first-child {
			td, th {
				border-top: none;
			}
		}
	}
}
</style>